// extracted by mini-css-extract-plugin
module.exports = {"rejection-title":"RejectionDetails_rejection-title__2oPcF","rejection-text":"RejectionDetails_rejection-text__2S2Ak","completion-title":"RejectionDetails_completion-title__1I9VS"};